import { SagaIterator } from 'redux-saga'
import * as effects from 'redux-saga/effects'
import * as api from './api'
import * as actions from './actions'
import { formatErrorMessage } from '../../utils/helpers'
import * as Sentry from '@sentry/react'

function* fetchRandomWork(): SagaIterator {
  try {
    const contest = yield effects.call(api.fetchRandomWork)
    yield effects.put(actions.fetchRandomWorkSuccess(contest))
  } catch (error) {
    console.warn('Cannot fetch random contest', error)
    yield effects.put(actions.fetchRandomWorkFailure(formatErrorMessage(error)))
    Sentry.captureException(error)
  }
}

function* fetchCriteries(payload: {
  contest_id: string
  nomination_id: string
}): SagaIterator {
  try {
    const { contest_id, nomination_id } = payload
    const criteries = yield effects.call(
      api.fetchCriteries,
      contest_id,
      nomination_id
    )
    yield effects.put(actions.fetchCriteriesSuccess(criteries.data))
  } catch (error) {
    console.warn('Cannot fetch criteries', error)
    yield effects.put(actions.fetchCriteriesFailure(formatErrorMessage(error)))
    Sentry.captureException(error)
  }
}

function* fetchWork(payload: { userContestId: string }): SagaIterator {
  try {
    const contest = yield effects.call(api.fetchWork, payload.userContestId)
    yield effects.put(actions.fetchWorkSuccess(contest))
  } catch (error) {
    console.warn('Cannot fetch contest', error)
    yield effects.put(actions.fetchWorkFailure(formatErrorMessage(error)))
    Sentry.captureException(error)
  }
}

function* sendWorkReview(payload: {
  userContestId: string
  criteries: { criterion_id: string; point_value: number }
  isUpdateWork: boolean
}): SagaIterator {
  try {
    const { userContestId, criteries, isUpdateWork } = payload
    const work = yield effects.call(
      api.sendWorkReview,
      userContestId,
      criteries
    )
    yield effects.put(actions.sendWorkReviewSuccess(work))
    if (isUpdateWork) {
      yield effects.put(actions.fetchWork(userContestId))
    } else {
      yield effects.put(actions.fetchRandomWork())
    }
    window.scrollTo({ top: 0, left: 0 })
  } catch (error) {
    console.warn('Cannot send work review', error)
    yield effects.put(actions.sendWorkReviewFailure(formatErrorMessage(error)))
    Sentry.captureException(error)
  }
}

function* downloadFile(payload: {
  file_id: string
  url: string
  name: string
  onProgress: (file_id: string, percent: number) => void
}): SagaIterator {
  try {
    const { file_id, url, name, onProgress } = payload
    yield effects.call(api.downloadFile, url, name, (percent: number) =>
      onProgress(file_id, percent)
    )
  } catch (error) {
    console.warn('Cannot download file', error)
    Sentry.captureException(error)
  }
}

function* watchFetchRandomWork(): SagaIterator {
  yield effects.takeEvery(actions.fetchRandomWork.toString(), fetchRandomWork)
}

function* watchFetchCriteries(): SagaIterator {
  yield effects.takeEvery(actions.fetchCriteries.toString(), fetchCriteries)
}

function* watchFetchWork(): SagaIterator {
  yield effects.takeEvery(actions.fetchWork.toString(), fetchWork)
}

function* watchSendWorkReview(): SagaIterator {
  yield effects.takeEvery(actions.sendWorkReview.toString(), sendWorkReview)
}

function* watchDownloadFile(): SagaIterator {
  yield effects.takeEvery(actions.downloadFile.toString(), downloadFile)
}

export default function* watchProfileExpertCabinet(): SagaIterator {
  yield effects.all([
    effects.fork(watchFetchRandomWork),
    effects.fork(watchFetchCriteries),
    effects.fork(watchFetchWork),
    effects.fork(watchSendWorkReview),
    effects.fork(watchDownloadFile),
  ])
}
